import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import {
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
} from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';

import FeedbackButton from 'components/feedback/FeedbackButton';
import {
  sectionOfPath,
  useCurrentFeedbackSection,
} from 'services/feedback/feedbackSection';
import InlookLogo from '../../assets/InlookLogoWhite.png';
import LanguageFlags from './LanguageFlags';
import Sidebar from './Sidebar';
import UserLogo from '../../assets/GenericUser.svg';
import '../../style/layout/NavMenu.css';

const NavMenu = ({ currentUser }: { currentUser: any }): JSX.Element | null => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const headerText = useSelector((state: any) => state.navMenu.text);
  const headerLink: string = useSelector((state: any) => state.navMenu.link);
  const headerPhase: string = useSelector((state: any) => state.navMenu.phase);
  const headerSubText: string = useSelector(
    (state: any) => state.navMenu.subText
  );
  // E.g. "TESTI" in the test environment, so users always know they are not in production
  const environmentLabel: string | null | undefined = useSelector(
    (state: any) => state.settings.settings?.environmentLabel
  );
  const location = useLocation();
  const openSection = useCurrentFeedbackSection();

  return (
    <header>
      {sidebarOpen ? (
        <Sidebar isOpen={sidebarOpen} closeFunction={setSidebarOpen} />
      ) : null}
      <div className="space-reserver" />
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 navbar-color navbar-size fixed-top"
        light
        style={{ padding: 0 }}
      >
        <Container className="full-container">
          <Nav
            className="navmenu-hamburger-button"
            onClick={() => {
              setSidebarOpen(true);
            }}
          >
            <p className="navmenu-hamburger-text">☰</p>
          </Nav>
          <NavbarBrand tag={Link} to="/" style={{ padding: 0 }}>
            <img
              alt="Inlook"
              height="41px"
              src={InlookLogo}
              style={{ float: 'left' }}
              width="200px"
            />
          </NavbarBrand>
          <Collapse className="collapse-section" isOpen navbar>
            <Nav>
              <NavItem>
                <div className="nav-title">
                  {/* The phase of the sale, e.g. Mahdollisuus, before the name of the site */}
                  {headerPhase ? (
                    <span className="nav-phase">{headerPhase}</span>
                  ) : null}
                  {/* E.g. the name of the offer opens the list of all offers */}
                  <h2 title={headerText}>
                    {headerLink ? (
                      <Link to={headerLink}>{headerText}</Link>
                    ) : (
                      headerText
                    )}
                  </h2>
                  {headerSubText ? (
                    <span className="nav-sub-title" title={headerSubText}>
                      {headerSubText}
                    </span>
                  ) : null}
                </div>
              </NavItem>
            </Nav>
          </Collapse>
          <Collapse isOpen navbar>
            <Nav className="mr-auto" navbar />
            <Nav pullright="true" className="navmenu-right">
              {/* Feedback on the section open now, e.g. the calculation of a position */}
              {currentUser != null ? (
                <NavItem>
                  <FeedbackButton
                    className="feedback-button-header"
                    location={[openSection?.location, location.pathname]
                      .filter(Boolean)
                      .join(' ')}
                    page={
                      openSection?.section ?? sectionOfPath(location.pathname)
                    }
                  />
                </NavItem>
              ) : null}
              {environmentLabel ? (
                <NavItem>
                  <div className="environment-label" role="status">
                    {environmentLabel}
                  </div>
                </NavItem>
              ) : null}
              <NavItem>
                <Link className="account-name-container" to="NotYetImplemented">
                  <img src={UserLogo} alt="" className="account-logo" />
                  {currentUser != null ? (
                    <div className="account-name">
                      {currentUser.firstName} {currentUser.lastName}
                    </div>
                  ) : null}
                </Link>
                <LanguageFlags />
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

const mapStateToProps = (state: any) => ({
  currentUser: state.users.current,
});

export default connect(mapStateToProps)(NavMenu);
